import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconChevronRight = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='28'
            viewBox='0 0 28 28'
            width='28'
            xmlns='http://www.w3.org/2000/svg'>
            <mask
                height='20'
                id='mask0_1232_198'
                maskUnits='userSpaceOnUse'
                width='20'
                x='4'
                y='4'>
                <rect
                    fill={fill}
                    height='20'
                    width='20'
                    x='4'
                    y='4'/>
            </mask>
            <g mask='url(#mask0_1232_198)'>
                <path
                    d='M15.1641 14.0005L11.2266 10.063L12.0005 9.28906L16.712 14.0005L12.0005 18.712L11.2266 17.938L15.1641 14.0005Z'
                    fill='white'/>
            </g>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconChevronRight;
